import React from 'react';
import Navbar from '../components/NavBar';
import Footer from '../components/Footer';

const Layout = ({ children }) => {
 return (
    <div className="flex flex-col min-h-screen font-sans">
    <Navbar/>
      {children}
    <Footer/>
  </div>
);
};
export default Layout;